import React  from 'react';
import {   Route, Routes, Navigate } from 'react-router-dom';
import ProtectedRoute from '../auth/ProtectedRoutes.js';
import {  useAuth } from '../auth/AuthContext.js';  

// Components Imports
import NotActiveUser from '../pages/NotActiveUser.jsx';
import HomePage from '../pages/HomePage.jsx';
import LoginPage from '../pages/LoginPage.jsx';
import SupportPage from '../pages/SupportPage.jsx';
import NewDeposit from '../pages/NewDeposit.jsx';
import EmpEvaluationPage from '../pages/evaluation/EmpEvaluationPage.jsx';
import ProfilePage from '../pages/ProfilePage.jsx';
import MyEvaluation from '../pages/evaluation/MyEvaluation.jsx';
import SubordinateEvaluation from '../pages/evaluation/SubordinateEvaluation.jsx';
import ArchiveEvaluations from '../pages/evaluation/ArchiveEvaluations.jsx';
import CreateNewEvaluation from '../pages/evaluation/CreateNewEvaluation.jsx';
import UpdateEvaluation from '../pages/evaluation/UpdateEvaluation.jsx';
import DetailsEvaluation from '../pages/evaluation/DetailsEvaluation.jsx';
import MySpinner from '../components/MySpinner.jsx';
import theme from '../theme/theme.js';
import { routePath } from './routePath.js';
import ResetPassword from '../pages/ResetPassword.jsx';
import EmpEditProfile from '../components/EmpEditProfile.jsx';
import EmployeeRequests from '../pages/EmployeeRequests.jsx';
import Register from '../pages/Register.jsx';
import DisplayDeposit from '../pages/DisplayDeposit.jsx';
import EmpPositionManagement from '../pages/EmpPositionManagement.jsx';
import AnnualEvaluationPage from '../pages/evaluation/AnnualEvaluationPage.jsx';

function AuthRoutes() {
    const { isAuthenticated, userInfo, isLoading } = useAuth();  
  
    if (isLoading) return <MySpinner color={theme.colors.primary} />; 
  const userRole=userInfo?.userType;
  
    return (
      <Routes>
      {/* Unprotected routes */}
      <Route path={routePath.login} element={<LoginPage />} />
      <Route path={routePath.resetPassword} element={<ResetPassword />} />
      <Route path={routePath.register} element={<Register />} />
    
      {/* Protected routes */}
      {isAuthenticated ? (
        <>
        {/* if user employee account is not active */}
          <Route path={routePath.notActiveUser} element={<ProtectedRoute element={<NotActiveUser />} />} />
          
          {/* Common protected routes */}
          <Route path={routePath.home} element={<ProtectedRoute element={<HomePage />} />} />
          <Route path={routePath.profile} element={<ProtectedRoute element={<ProfilePage />} />} />
          <Route path={routePath.profile} element={<ProtectedRoute element={<ProfilePage />} />} />
          <Route path={routePath.editProfile(':empId')} element={<ProtectedRoute element={<EmpEditProfile />} />} />
          <Route path={routePath.displayDeposit(':depositId')} element={<ProtectedRoute element={<DisplayDeposit />} />} />
          <Route path={routePath.support} element={<ProtectedRoute element={<SupportPage />} />} />
          <Route path={routePath.newDeposit(':itemId')} element={<ProtectedRoute element={<NewDeposit />} />} />
          <Route path={routePath.empPositionManagement} element={<ProtectedRoute element={<EmpPositionManagement />} />} />
    
          {/* Employee-specific evaluation routes */}
          
              <Route path={routePath.employeeEvaluation} element={<ProtectedRoute element={<EmpEvaluationPage />} />} />
              <Route path={routePath.myEvaluation} element={<ProtectedRoute element={<MyEvaluation />} />} />
              <Route path={routePath.subordinateEvaluation} element={<ProtectedRoute element={<SubordinateEvaluation />} />} />
              <Route path={routePath.updateEvaluation(':hierId')} element={<ProtectedRoute element={<UpdateEvaluation />} />} />
              <Route path={routePath.createNewEvaluation(':hierId')} element={<ProtectedRoute element={<CreateNewEvaluation />} />} /> 
               <Route path={routePath.archiveEvaluations} element={<ProtectedRoute element={<ArchiveEvaluations />} />} />
              <Route path={routePath.detailsEvaluation(':empEvalId')} element={<ProtectedRoute element={<DetailsEvaluation />} />} />
              <Route path={routePath.empRequests(':empId')} element={<ProtectedRoute element={<EmployeeRequests />} />} />
              <Route path={routePath.annualEvaluation} element={<ProtectedRoute element={<AnnualEvaluationPage />} />} />
       
          
        </>
      ) : ( 
        <Route path="*" element={<Navigate to={routePath.login} />} />
      )}
    </Routes>
    );
  }
  export default AuthRoutes;